<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row mt-2">

                <div class="form-group mb-2 me-2 col-md-4 col-lg-3 col-xl-3">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(WithdrawalStatus).filter(item => item === parseInt(item))"
                                   :custom-label="(opt) => helper.trans(`withdrawal_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.status')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-2 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-2 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-12 col-lg-4 col-xl-4">
                  <div class="d-flex align-items-center gap-1">
                    <label class="col-form-label text-capitalize-first p-0 me-1">{{ helper.trans("labels.owner") }}:</label>
                    <button type="button" class="btn btn-sm btn-outline-dark text-capitalize-first"  @click.prevent="toggleType()">{{ accountType ? helper.trans(`labels.${accountType}`) : helper.trans(`labels.select`)  }}</button>
                    <div class="w-100" v-if="accountType && accountType !== 'system'">
                      <Multiselect
                        class="multiselect-sm"
                        v-model="requestDTO.account"
                        :options="accounts"
                        :custom-label="(opt) => labelFor(accountType!, opt)"
                        track-by="id"
                        select-label="Select"
                        open-direction="bottom"
                        :multiple="false"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :clear-on-select="true"
                        :close-on-select="true"
                        :options-limit="100"
                        :limit="1000"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindAccounts"
                      >
                      </Multiselect>
                    </div>
                    <button v-if="accountType" type="button" class="btn btn-sm btn-link" @click.prevent="clearType()"><i class="fa fa-times"></i></button>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => exportData()" class="btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-download me-1"></i>{{ helper.trans('button.export') }}
                    </button>
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.initiator') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.session') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.owner") }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.sum') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.address.usdt') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.status") }}</th>
                    <th class="text-capitalize-first">{{ helper.trans("labels.tx_id") }}</th>
                    <th class="text-end">
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="withdrawal in response.items" :key="withdrawal.id" class="">
                    <td>
                      <div class="d-flex flex-column mt-1 mb-1">
                        <span>
                          <span v-b-tooltip.hover :title="withdrawal.id">{{ withdrawal.id.substring(0, 8) }}...</span> <copy-button :value="withdrawal.id"></copy-button>
                        </span>
                        <small class="text-secondary">{{ dateHelper.format(withdrawal.createdAt) }}</small>
                      </div>
                    </td>
                    <td>
                      <UserNameLabel v-if="withdrawal.createdBy" show-badge :user="withdrawal.createdBy"></UserNameLabel>
                    </td>
                    <td>
                      <div v-if="withdrawal.userSessionId" class="d-flex flex-column mt-1 mb-1">
                        <small class="text-secondary" v-b-tooltip.hover :title="helper.trans('labels.session_id')">#{{ withdrawal.userSessionId }}</small>
                        <span v-if="withdrawal.ip">{{ withdrawal.ip }}</span>
                        <small v-if="withdrawal.ua"
                               class="text-secondary text-truncate"
                               style="max-width: 14rem"
                               v-b-tooltip.hover
                               :title="withdrawal.ua"
                        >{{ withdrawal.ua }}</small>
                      </div>
                    </td>
                    <td>
                      <span v-if="withdrawal.traderAccount">
                        <small  class="badge bg-primary" v-b-tooltip.hover :title="helper.trans(`account_owner.trader`)">
                          T
                        </small>

                        {{ withdrawal.traderAccount?.user.name }} ({{ withdrawal.traderAccount?.traderEmail }})
                      </span>

                      <span v-if="withdrawal.merchantStoreAccount">
                        <small  class="badge bg-secondary" v-b-tooltip.hover :title="helper.trans(`account_owner.store`)">
                          M
                        </small>

                        {{ withdrawal.merchantStoreAccount?.user.name }} ({{ withdrawal.merchantStoreAccount?.merchantEmail }}) - {{ withdrawal.merchantStoreAccount?.storeName }}
                      </span>

                      <span v-if="withdrawal.userAccount">
                        <small class="badge bg-info" v-b-tooltip.hover :title="helper.trans(`account_owner.${withdrawal.userAccount?.user.role}`)">
                          {{ helper.trans(`user_roles.shorts.${withdrawal.userAccount?.user.role}`)}}
                        </small>

                        {{ withdrawal.userAccount?.user.name }} ({{ withdrawal.userAccount?.userEmail }})
                      </span>
                    </td>
                    <td>
                      <span>
                        {{ numberFormatter.formatMoney(withdrawal.sum, 2) }}
                      </span>
                      <div v-if="withdrawal.sum.currency !== withdrawal.debitedSum.currency">
                        <small class="text-secondary">
                          {{ numberFormatter.formatMoney(withdrawal.debitedSum, 2) }}
                        </small>
                      </div>

                    </td>
                    <td>{{ withdrawal.address }}</td>
                    <td>{{ helper.trans(`withdrawal_status.${withdrawal.status}`) }}</td>
                    <td>
                      <div v-if="withdrawal.txId">
                        {{ withdrawal.txId?.substring(0, 16) }}...
                        <copy-button :value="withdrawal.txId"></copy-button>
                        <a :href="`https://tronscan.org/#/transaction/${withdrawal.txId}`" target="_blank" class="ms-2">
                          <i class="fa fa-external-link"></i>
                        </a>
                      </div>
                    </td>
                    <td class="text-end">
                      <button v-if="(isAdmin || (isOperator && store.getters.hasPermission(UserPermission.PROCESS_WITHDRAWAL))) && withdrawal.status === 1" type="button" @click="cancelWithdrawal(withdrawal.id)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2">{{helper.trans('button.cancel')}}</button>
                      <button v-if="(isAdmin || (isOperator && store.getters.hasPermission(UserPermission.PROCESS_WITHDRAWAL))) && withdrawal.status === 1" type="button" @click="processWithdrawal(withdrawal.id)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize">{{helper.trans('button.withdraw')}}</button>
                      <button
                          v-if="isAdmin && withdrawal.canRenew && withdrawal.status === 2"
                          type="button"
                          @click="renewWithdrawal(withdrawal.id)"
                          class="btn btn-sm btn-outline-danger text-nowrap text-capitalize"
                      >
                        {{helper.trans('button.stop')}}
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="load()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import WithdrawalDTO from "@/models/WithdrawalDTO";
import TraderAccountDTO from "@/models/TraderAccountDTO";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantStoreAccountDTO from "@/models/MerchantStoreAccountDTO";
import UserAccountDTO from "@/models/UserAccountDTO";
import MerchantDTO from "@/models/MerchantDTO";
import {UserRole} from "@/models/enum/UserRole";
import {WalletType} from "@/models/enum/WalletType";
import {WithdrawalStatus} from "@/models/enum/WithdrawalStatus";
import Multiselect from "vue-multiselect";
import {DatePicker} from "v-calendar";
import {UserPermission} from "@/models/enum/UserPermission";
import UserDTO from "@/models/UserDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";

const api = new APIClient();
const notification = useNotification()
const defaultRequestDTO = {
  statuses: [WithdrawalStatus.STATUS_NEW, WithdrawalStatus.STATUS_PROGRESS],
  accountId: null,
  merchantId: null,
  fromDate: null,
  toDate: null,
}
const types = [null, 'system', 'trader', 'teamlead', 'referral', 'store', 'merchant'];

export default defineComponent({
  components: {
    UserNameLabel,
    Multiselect,
    DatePicker,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      page: 1,
      isLoading: false as boolean,
      accountType: null as string|null,
      accounts: [] as TraderAccountDTO[]|MerchantStoreAccountDTO[]|UserAccountDTO[]|MerchantDTO[],
      requestDTO: {...defaultRequestDTO} as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<WithdrawalDTO>
    });

    const dateParams = (): any => {
      const params: any = {}
      const fromDate = dateHelper.toUTC(state.requestDTO.fromDate)
      const toDate = dateHelper.toUTC(state.requestDTO.toDate)

      if (fromDate) {
        params.fromDate = fromDate
      }

      if (toDate) {
        params.toDate = toDate
      }

      return params
    }

    const load = async () => {
      state.response.offset = state.response.limit * (state.page - 1)
      loader.value?.show()
      const request: any = {
        statuses: state.requestDTO.statuses,
        accountId: state.accountType !== 'merchant' ? (state.requestDTO.account ? state.requestDTO.account.id : state.requestDTO.accountId) : null,
        ...dateParams(),
      }

      if (state.accountType === 'merchant' && state.requestDTO.account) {
        request.merchantId = state.requestDTO.account.id
      } else if (state.requestDTO.merchantId) {
        request.merchantId = state.requestDTO.merchantId
      }

      state.response = await api.withdrawals(state.response, request)
      const accountIds = state.response.items.map((item) => item.accountId);
      const userIds = state.response.items
        .filter((item) => item.createdById)
        .map((item) => item.createdById);

      let users = {} as UserDTO[]|any;
      if (userIds.length > 0) {
        for (const user of (await api.users({offset:0, limit: 1000} as PaginationDTO, {ids: userIds})).items) {
          users[user.id] = user
        }
      }

      let traderAccounts = {} as TraderAccountDTO[]|any;
      for (const account of (await api.traderAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
        traderAccounts[account.account.id] = account
      }

      let storeAccounts = {} as MerchantStoreAccountDTO[]|any;
      for (const account of (await api.merchantStoreAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
        storeAccounts[account.account.id] = account
      }

      let userAccounts = {} as UserAccountDTO[]|any;
      for (const account of (await api.userAccounts({offset:0, limit: 1000} as PaginationDTO, {ids: accountIds})).items) {
        userAccounts[account.account.id] = account
      }

      for (const item of state.response.items) {
        item.traderAccount = traderAccounts[item.accountId] ?? null;
        item.merchantStoreAccount = storeAccounts[item.accountId] ?? null;
        item.userAccount = userAccounts[item.accountId] ?? null;
        item.createdBy = item.createdById ? users[item.createdById] ?? null : null;
      }

      loader.value?.hide()
    }

    const processWithdrawal = async (id: string) => {
      loader.value?.show()
      await api.processWithdrawal(id)
      load()
    }

    const cancelWithdrawal = async (id: string) => {
      loader.value?.show()
      await api.cancelWithdrawal(id)
      load()
    }

    const renewWithdrawal = async (id: string) => {
      loader.value?.show()
      await api.renewWithdrawal(id)
      load()
    }

    const exportData = async () => {
      try {
        loader.value?.show()
        const params: any = {...dateParams()}

        if (state.requestDTO.statuses && state.requestDTO.statuses.length > 0) {
          params.statuses = state.requestDTO.statuses.map((status: any) => Number(status))
        }
        
        if (state.requestDTO.account) {
          if (state.accountType === 'merchant') {
            params.merchantId = state.requestDTO.account.id
          } else {
            params.accountId = state.requestDTO.account.id
          }
        } else if (state.requestDTO.accountId) {
          params.accountId = state.requestDTO.accountId
        } else if (state.requestDTO.merchantId) {
          params.merchantId = state.requestDTO.merchantId
        }

        const blob = await api.withdrawalsExport(params)
        const filename = `withdrawals_${new Date().toISOString().split('T')[0]}.xlsx`
        helper.downloadBlob(blob, filename)
      } catch (error) {
        notification.notify({
          title: 'Ошибка экспорта',
          text: 'Не удалось экспортировать данные ',
          type: 'error'
        })
      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {...defaultRequestDTO}
      load()
    }

    onMounted(() => {
      load();
    });

    const labelFor = (type: string, opt: TraderAccountDTO|UserAccountDTO|MerchantStoreAccountDTO|MerchantDTO) => {
      if (type === 'store') {
        const storeAccount = opt as MerchantStoreAccountDTO
        return `${storeAccount.user.name} (${storeAccount.user.email}) - ${storeAccount.storeName}`
      }

      if (type === 'merchant') {
        const merchant = opt as MerchantDTO
        return `${merchant.name} (${merchant.email})`
      }

      const account = opt as TraderAccountDTO|UserAccountDTO
      return `${account.user.name} (${account.user.email})`
    }

    const toggleType = () => {
      const index = state.accountType ? types.indexOf(state.accountType) : 0;
      let newValue = types[index + 1];
      state.accountType = newValue ?? types[0]
      state.accounts = []
      state.requestDTO.account = null;
      state.requestDTO.accountId = null
      state.requestDTO.merchantId = null
      if (state.accountType === 'system') {
        state.requestDTO.accountId = '00000000-0000-0000-0000-000000000000';
      } else if (state.accountType === null) {
        state.requestDTO.accountId = null
      }
    }

    const clearType = () => {
      state.accountType = null
      state.accounts = []
      state.requestDTO.account = null;
      state.requestDTO.accountId = null
      state.requestDTO.merchantId = null
    }

    const asyncFindAccounts = debounce(async (query) => {
      state.isLoading = true
      switch (state.accountType) {
        case 'trader':
          state.accounts = (await api.traderAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'teamlead':
          state.accounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.TRADER_TEAM_LEAD})).items;
          break;
        case 'referral':
          state.accounts = (await api.userAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query, userRole: UserRole.REFERRAL})).items;
          break;
        case 'store':
          state.accounts = (await api.merchantStoreAccounts({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
        case 'merchant':
          state.accounts = (await api.merchants({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
          break;
      }
      state.isLoading = false
    }, 500);

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed<boolean>(() => store.getters.isOperator),
      labelFor,
      toggleType,
      clearType,
      asyncFindAccounts,
      applyFilters,
      clearFilters,
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      helper,
      load,
      processWithdrawal,
      cancelWithdrawal,
      renewWithdrawal,
      exportData,
      UserRole,
      WithdrawalStatus,
      store,
      UserPermission
    }
  }
})
</script>
